import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { TopbarContainer } from '..';
import {
  Footer,
  LayoutSideNavigation,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  Page,
  RentalAgreement,
} from '../../components';
import config from '../../config';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { injectIntl, intlShape } from '../../util/reactIntl';

import css from './RentalAgreementPage.css';

const RentalAgreementPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const tabs = [
    {
      text: intl.formatMessage({ id: 'RentalAgreementPage.tosTabTitle' }),
      selected: true,
      linkProps: {
        name: 'RentalAgreementPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RentalAgreementPage.termsOfServiceTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermsOfServicePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RentalAgreementPage.privacyPolicyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'DataDeletionInstruction.tosTabTitle' }),
      selected: false,
      linkProps: {
        name: 'DataDeletionInstruction',
      },
    },
  ];
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'RentalAgreementPage.schemaTitle' }, { siteTitle });
  const schemaDescription = " Get to know in detail Drive lah's rental agreement entered between the Host and the Guest for the rental of the Vehicle in mentioned terms and conditions";
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema} description={schemaDescription}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="RentalAgreementPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.heading}>
              {/* <FormattedMessage id="PrivacyPolicyPage.heading" /> */}
            </h1>
            <RentalAgreement />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

RentalAgreementPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const RentalAgreementPage = compose(
  connect(mapStateToProps),
  injectIntl
)(RentalAgreementPageComponent);

export default RentalAgreementPage;
